@if (isOpen) {
<div
  class="vw-celebration fixed inset-0 z-[1000] flex items-center justify-center px-6"
  role="dialog"
  aria-modal="true"
  (click)="close()"
>
  <div class="absolute inset-0 bg-vw-scrim"></div>

  <!-- Confettis : purement décoratifs, donc masqués aux lecteurs d'écran -->
  <div class="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    @for (c of confetti; track $index) {
    <span
      class="vw-confetti"
      [style.left.%]="c.left"
      [style.background]="c.color"
      [style.animation-delay.s]="c.delay"
      [style.animation-duration.s]="c.duration"
      [style.--vw-tilt]="c.tilt + 'deg'"
    ></span>
    }
  </div>

  <div
    class="vw-celebration-card relative w-full max-w-sm rounded-sheet bg-vw-surface px-6 pb-6 pt-0 text-center shadow-float"
  >
    <!-- Willy déborde de la carte : il annonce la nouvelle, il n'illustre pas -->
    <img
      src="/assets/images/willy/willy_perfecto.png"
      alt=""
      aria-hidden="true"
      class="vw-celebration-willy mx-auto -mt-16 h-32 w-32 object-contain"
    />

    <span
      class="mt-1 inline-flex items-center gap-1.5 rounded-pill bg-gradient-to-r from-vw-premium-accent to-vw-premium-line px-3 py-1 text-caption font-semibold uppercase tracking-wide text-vw-on-color"
    >
      <!-- Un essai n'est pas un abonnement : le badge le dit. -->
      {{ (trial ? 'premium.celebration.badge-trial' : 'premium.celebration.badge') | translate }}
    </span>

    <!-- `text-balance` évite qu'un titre traduit laisse un « ! » seul sur sa
         ligne : les six langues n'ont pas la même longueur. -->
    <h2 class="mt-3 text-balance font-display text-title-l text-vw-ink">
      {{
        (trial
          ? 'premium.celebration.title-trial'
          : 'premium.celebration.title'
        ) | translate
      }}
    </h2>

    <!-- Essai : la date de fin, c'est ce que la personne veut savoir. -->
    <p class="mt-2 text-pretty text-body-s text-vw-muted" data-testid="celebration-subtitle">
      @if (trial && trialEnd) {
        {{ 'premium.celebration.subtitle-trial-until' | translate: { date: (trialEnd | vwDate: 'numeric') } }}
      } @else {
        {{
          (trial
            ? 'premium.celebration.subtitle-trial'
            : 'premium.celebration.subtitle'
          ) | translate
        }}
      }
    </p>

    <ul class="mt-4 flex flex-col gap-2 text-left">
      @for (k of ['lunar', 'harvest', 'willy', 'garden']; track k) {
      <li class="flex items-start gap-2.5">
        <span
          class="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-pill bg-vw-surface-tint text-vw-primary"
        >
          <svg viewBox="0 0 24 24" class="h-3 w-3" fill="none" aria-hidden="true">
            <path
              d="M5 13l4 4L19 7"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span class="text-body-s text-vw-ink">
          {{ 'premium.celebration.perks.' + k | translate }}
        </span>
      </li>
      }
    </ul>

    <!-- Le bouton principal de l'app (48 px), plus un bouton fait main en 14 px. -->
    <vw-button look="primary" customClass="w-full" class="mt-5 block" data-testid="celebration-cta"
      [label]="'premium.celebration.cta' | translate" (onClick)="close()"></vw-button>
  </div>
</div>
}
